import storageService from '../../../../common/service/storageService';
import { STORAGE } from '../constants/storage';
import { IBuiltCar } from '../../../../common/model/IBuiltCar';

const variantStorage = {
  getSelectedVariantId(modelId: string): string {
    return storageService.get(STORAGE.SELECTED_VARIANT + modelId) || null;
  },

  setSelectedVariantId(modelId: string, variantId: string): void {
    storageService.set(STORAGE.SELECTED_VARIANT + modelId, variantId);
  },

  getCustomisedCar(variantId: string): IBuiltCar {
    let customisedCar: IBuiltCar;

    try {
      customisedCar = JSON.parse(storageService.get(STORAGE.CUSTOMISED_CAR + variantId) || 'null');
    } catch (e) {
      customisedCar = null;
    }

    return customisedCar;
  },

  setCustomisedCar(variantId: string, customisedCar: IBuiltCar): void {
    storageService.set(
      STORAGE.CUSTOMISED_CAR + variantId,
      JSON.stringify({
        carId: customisedCar.carId,
        accessories: customisedCar.accessories,
        packs: customisedCar.packs,
        servicePlan: customisedCar.servicePlan,
      }),
    );
  },
};

export default variantStorage;
